export default __webpack_public_path__ + "static/media/AF.826af8f8.svg";